module.exports = __webpack_public_path__ + "static/img/Jaipur.c30f422.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/city/Jaipur.png
// module id = KYTg
// module chunks = 12